import React from "react";
import { ThemeProvider } from "./contexts/ThemeContext";
import { AuthProvider } from "./contexts/AuthContext";
import { ChatProvider } from "./contexts/ChatContext";
import { RbacConfigProvider } from "./contexts/RbacConfigContext";
import AppRoutes from "./routers/AppRoutes";
import SessionGate from "./components/SessionGate";
import "./App.css";

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <ChatProvider>
          <SessionGate>
            <RbacConfigProvider>
              <AppRoutes />
            </RbacConfigProvider>
          </SessionGate>
        </ChatProvider>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
